<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <div
        v-for="day in days"
        :key="day"
        class="form-row mb-2 align-items-center"
      >
        <div class="col-auto w-32">
          <div class="form-check">
            <input
              :id="field.attribute + day"
              :checked="isOpen(day)"
              type="checkbox"
              class="form-check-input"
              @change="toggleOpen(day)"
            />
            <label :for="field.attribute + day" class="form-check-label">
              {{ day }}
            </label>
          </div>
        </div>
        <template v-if="isOpen(day)">
          <div class="col-auto">
            <flat-pickr
              v-model="fieldValue[day].gte"
              :config="flatpickrConfig"
              class="form-control w-32"
            >
            </flat-pickr>
          </div>
          <div class="col-auto">
            <flat-pickr
              v-model="fieldValue[day].lte"
              :config="flatpickrConfig"
              class="form-control w-32"
            >
            </flat-pickr>
          </div>
        </template>
      </div>
    </template>
  </component>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import FlatPickr from "vue-flatpickr-component";

export default {
  name: "FormWorkingHoursField",

  components: {
    FlatPickr,
  },

  mixins: [FieldMixin],

  data() {
    const self = this;

    return {
      days: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
      flatpickrConfig: {
        enableTime: true,
        noCalendar: true,
      },
    };
  },

  created() {
    if (!this.fieldValue || typeof this.fieldValue !== "object") {
      this.fieldValue = {};
    }
  },

  methods: {
    isOpen(day) {
      return this.fieldValue && this.fieldValue[day];
    },
    toggleOpen(day) {
      if (this.isOpen(day)) {
        this.fieldValue[day] = null;
      } else {
        this.fieldValue[day] = {
          gte: "8:00",
          lte: "19:00",
        };
      }

      this.$forceUpdate();
    },
  },
};
</script>
